module.exports = __webpack_public_path__ + "static/img/way_three_main.89ee7ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main/products/way_three_main.png
// module id = n7Za
// module chunks = 1